module.exports = __webpack_public_path__ + "img/banner-bg.b52173ce.png";